export default {
  name: 'International Medical Department',
  index: {
    title: 'Introduction to the International Medical Department',
    navs: [
      {icon: require('@/page/gjyxb/assets/en/就诊预约入口-英@2x.png')},
      {icon: require('@/page/gjyxb/assets/en/保险公司名单-英@2x.png')}
    ],
    notice: 'Warm Prompt：'
  },
  introduce: {
    title: 'Introduction to the International'
  },
  picc: {
    title: 'Insurance Company List',
    notice: 'Please check with your insurance company or our direct billing company list to see if your insurance is accepted by our hospital.'
  },
  pre: {
    title: 'Visit appointment',
    btn: 'Visit Application Form'
  },
  form1: {
    title: 'Visit appointment',
    sexes: ['Male', 'Female'],
    errorMsg: 'Please fill in',
    yzmError: "captcha error",
    phoneErrorMsg: "Incorrect phone number format",
    nameRuleMsg: 'Exceeded the maximum number of words',
    next: 'NEXT',
    form: {
      name: "Patient Name",
      namePlaceholder: 'Enter',
      sex: 'Gender',
      birthday: 'Birthday',
      selectPlaceholder: 'Please select',
      country: 'Countries or regions',
      zj: 'Document number',
      bah: 'SAHZU Medical Record Number (If applicable)',
      address: 'Permanent Address in China'
    }
  },
  form2: {
    title: 'Visit appointment',
    next: 'NEXT',
    form: {
      t1: 'Contact Number (in China)',
      phone: "Mobile Number",
      namePlaceholder: 'Enter',
      email: 'E-mail',
      t2: 'Emergency Contact',
      name: 'Name',
      gx: 'Relationship to the Patient',
      selectPlaceholder: 'Please select',
      mobile: 'Phone Number'
    }
  },
  form3: {
    title: 'Visit appointment',
    next: 'Submit',
    success: 'Success',
    form: {
      date: "Request Date",
      namePlaceholder: 'Enter',
      ks: 'Request Department',
      yzm: 'Enter the verification code',
      ys: 'Preferred Physician',
      ms: 'Description of the condition',
      selectPlaceholder: 'Please select',
      placeholder: 'Please describe the reason of consultation /signs or symptoms'
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/locales/en.js